'use strict';

var Link = require('../Link');
var ListItem = require('../ListItem');
function renderCompanyListItems() {
	return {

		getCompanyListItems: function render(config, deps) {
			var _ = deps.underscore;
			var user = config.UserInfo;
			var memberships = config.memberships;

			return _.reduce(memberships, function(result, membership) {
				var clickFunction = !config.jQueryDisabled ? "changeCompanyContext('" + user.user_id + "', '" + membership.company.uuid + "')" : undefined;
				var companyLink = new Link({
					labelRaw: membership.company.name,
					isVisible: true,
					value: membership.company.uuid,
					clickFunction: clickFunction
				}).render(config, deps);
				result += new ListItem({
					linkComponent: companyLink,
					className: membership.company.uuid === user.company_id ? 'selected' : ''
				}).render(config, deps);

				return result;
			}, '');
		}
	};
}

module.exports = {
	renderCompanyListItems: renderCompanyListItems
};



//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/views/list-items/company-list-items.js
// module id = 29
// module chunks = 0